import { SET_DEALER_DATA, SET_DEALER_LOGO_URL } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.dealerData, action) {
  switch (action.type) {
    case SET_DEALER_DATA: {
      return action.payload;
    }
    case SET_DEALER_LOGO_URL: {
      return { ...state, dealerLogoURL: action.payload };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/dealerData/reducer.js